import dayjs from "dayjs";

export function parseDate(dob) {
    if (!dob) return '';
    const [ date ] = dob.split("T");
    const [ year, month, day ] = date.split("-");

    return `${ month }/${ day }/${ year }`;
}

export const dateOfBirthFormatter = (dob) => {
    return dayjs(dob).format("MM/DD/YYYY");
}

export const dateFormatter = dateOfBirthFormatter;

export const dateTimeFormatter = (date) => {
    if (!dayjs(date).isValid()) return "NA"
    return dayjs(date).format("MMMM Do YYYY hh:mm A");
}

export const timeFormatter = (date) => {
    return dayjs(date).format("hh:mm A");
}
